import { render, staticRenderFns } from "./RefundCardOption.vue?vue&type=template&id=21c063ad&scoped=true&"
import script from "./RefundCardOption.vue?vue&type=script&lang=js&"
export * from "./RefundCardOption.vue?vue&type=script&lang=js&"
import style0 from "./RefundCardOption.vue?vue&type=style&index=0&id=21c063ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c063ad",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
